import { render, staticRenderFns } from "./NotifyTaskList.vue?vue&type=template&id=57d88466&scoped=true"
import script from "./NotifyTaskList.vue?vue&type=script&lang=js"
export * from "./NotifyTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d88466",
  null
  
)

export default component.exports